import React from 'react'

export const TileReadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_48_1011)">
      <path d="M20.6133 6.2063C20.6133 7.75903 20.0801 9.05981 19.0195 10.1262C17.959 11.1868 16.6523 11.72 15.0996 11.72C13.5527 11.72 12.2461 11.1868 11.1855 10.1262C10.125 9.06567 9.5918 7.75903 9.5918 6.2063C9.5918 4.65356 10.125 3.35278 11.1855 2.28638C12.2461 1.21997 13.5586 0.698486 15.1055 0.698486C16.6582 0.698486 17.959 1.23169 19.0254 2.29224C20.0918 3.35278 20.6191 4.65942 20.6133 6.2063Z" />
      <path d="M27.8789 12.0305V24.7102C27.8789 25.4075 27.3398 25.9817 26.6484 26.0286C24.7441 26.1633 22.8691 26.5969 21.0996 27.3118C19.2012 28.0735 17.4258 29.1164 15.832 30.4055C15.3457 30.7922 14.6602 30.7922 14.1738 30.4055C12.5801 29.1164 10.8047 28.0735 8.90625 27.3118C7.13672 26.5969 5.26172 26.1633 3.35742 26.0286C2.66602 25.9817 2.12695 25.4016 2.12695 24.7102V12.0305C2.13281 11.2981 2.72461 10.7063 3.45703 10.7063C3.50391 10.7063 3.54492 10.7063 3.5918 10.7121C5.33789 10.8879 7.07227 11.3743 8.80078 12.177C11.0039 13.2024 13.0781 14.6321 15.0059 16.4719C16.9395 14.6379 19.0078 13.2024 21.2109 12.177C22.9336 11.3743 24.6738 10.8879 26.4199 10.7121C27.1465 10.636 27.8027 11.1633 27.8789 11.8957C27.873 11.9426 27.8789 11.9895 27.8789 12.0305Z" />
    </g>
  </svg>
)
